export default {
  user: {
    sellerId: null,
  },
  isPending: false,
  errorMessage: null,
  isPersistingUserPending: false,
  errorOfPersistUser: null,
  isLoggedIn: false,
  isAnonymous: false,
};
